
  <h1 mat-dialog-title>Select Builder</h1>
  <div [formGroup]="builderForm">

    <mat-form-field style="width:80%">
    <mat-label>Customer:{{customer_name}} </mat-label>
    <input id='customerfield' #customername matInput placeholder="Type builder name here" formControlName = "customer_id" [matAutocomplete] = "custid">
    </mat-form-field>

    <mat-autocomplete #custid = "matAutocomplete" (optionSelected)="onSelectCustomer($event.option.value)" [displayWith]="displayFunctionCustomer">
      <mat-option *ngFor="let contractor of (customer$ | async)" [value]="contractor">
        <span>{{ contractor.customer_name}}</span>
      </mat-option>
    </mat-autocomplete>

    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [disabled]="builderForm.invalid" (click)="onYesClick()">Done</button>
    </div>
  </div>
  